import styled, { css } from 'styled-components';

/* Page layout */
export const PageContainer = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 32px;
  text-align: left;
  font-size: 14px;
  color: rgba(46, 47, 51, 0.88);
  font-family: 'Pretendard JP', sans-serif;

  @media (max-width: 480px) {
    gap: 24px;
  }
`;

export const PageHeader = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`;

export const PageTitle = styled.h1`
  position: relative;
  font-size: 28px;
  letter-spacing: -0.02em;
  line-height: 135.8%;
  color: #171719;
  font-weight: 700;
  margin: 0;
`;

export const PageContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

/* Section common */
export const Section = styled.section`
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 8px;

  @media (max-width: 480px) {
    gap: 12px;
  }
`;

export const SectionHeader = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`;

export const SectionTitle = styled.h3`
  position: relative;
  letter-spacing: 0.01em;
  line-height: 142.9%;
  font-weight: 600;
  margin: 0;
  font-size: 14px;
  color: rgba(46, 47, 51, 0.88);
`;

/* Banner section */
export const BannerContent = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 16px;
  position: relative;
  width: 100%;
  box-sizing: border-box;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
  }
`;

export const DragHandle = styled.div`
  position: absolute;
  left: -20px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  cursor: grab;
  border-radius: 4px;
  transition: background-color 0.2s ease;
  opacity: 0.5;

  &:hover {
    background-color: rgba(112, 115, 124, 0.1);
    opacity: 1;
  }

  &:active {
    cursor: grabbing;
  }
`;

export const BannerImage = styled.div`
  width: 336px;
  height: 116px;
  flex: 0 0 336px;

  @media (max-width: 768px) {
    width: 100%;
    height: 200px;
  }
`;

export const BannerForm = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  gap: 16px;
  font-size: 16px;
  color: rgba(55, 56, 60, 0.28);
  width: 100%;
  min-width: 0;
`;

export const TitleRow = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 8px;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 12px;
  }
`;

export const TitleInput = styled.div`
  flex: 1;
  min-width: 0;
  width: 100% !important;

  .input {
    width: 100% !important;
  }
`;

export const ColorInputWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid rgba(112, 115, 124, 0.16);
  border-radius: 12px;
  padding: 8px 12px;
  background-color: white;
  width: 140px;
  min-width: 140px;
  flex-shrink: 0;
`;

export const ColorPicker = styled.input`
  width: 24px;
  height: 24px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  background: none;
  outline: none;
  flex-shrink: 0;
`;

export const ColorTextInput = styled.input`
  border: none;
  outline: none;
  background: none;
  font-family: 'Pretendard JP', sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #448181 !important;
  letter-spacing: 0.01em;
  width: 90px;
  text-transform: uppercase;

  &::placeholder {
    color: rgba(68, 129, 129, 0.5) !important;
  }
`;

export const CaptionRow = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 12px;
  }
`;

export const CaptionInput = styled.div`
  flex: 1;
`;

export const BannerActions = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
  margin-top: 8px;
`;

export const CreateBannerButton = styled.div`
  width: 120px;
  height: 40px;
  font-size: 14px;
  padding: 8px 16px;
`;

export const SectionActions = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
  margin-top: 16px;
`;

export const SectionSaveButton = styled.div`
  width: 160px;
  height: 40px;
  font-size: 14px;
  padding: 8px 16px;
`;

export const ErrorMessage = styled.div`
  color: #e52222;
  font-size: 12px;
  margin-top: 4px;
  padding: 4px 8px;
  background: rgba(229, 34, 34, 0.1);
  border-radius: 4px;
  border: 1px solid rgba(229, 34, 34, 0.2);
`;

export const LoadingMessage = styled.div`
  text-align: center;
  padding: 20px;
  color: rgba(112, 115, 124, 0.8);
  font-size: 14px;
`;

/* Curation management */
export const CurationSet = styled.div`
  width: 100%;
  margin-bottom: 32px;
  padding: 20px;
  border: 1px solid rgba(112, 115, 124, 0.16);
  border-radius: 12px;
  background: #fff;
`;

export const CurationForm = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: flex-start;
  gap: 8px;
  margin-bottom: 16px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 16px;
  }
`;

export const CurationFormGroup = styled.div`
  flex: 1;
  display: flex;
  gap: 8px;
`;

export const CurationButtons = styled.div`
  display: flex;
  gap: 8px;
  align-items: flex-end;
`;

export const CurationSectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(112, 115, 124, 0.16);
`;

export const CurationSectionTitle = styled.h4`
  font-size: 16px;
  font-weight: 600;
  color: #171719;
  margin: 0;
`;

export const CurationSectionDescription = styled.p`
  font-size: 14px;
  color: rgba(112, 115, 124, 0.8);
  margin: 4px 0 0 0;
`;

export const CurationSectionActions = styled.div`
  display: flex;
  gap: 8px;
`;

export const LectureGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 16px;
  margin-top: 16px;
`;

export const LectureCard = styled.div`
  position: relative;
  border: 1px solid rgba(112, 115, 124, 0.16);
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
  transition: all 0.2s ease;

  &:hover {
    border-color: #448181;
    box-shadow: 0 2px 8px rgba(68, 129, 129, 0.1);
  }

  &:hover button {
    opacity: 1;
  }
`;

export const LectureCardImage = styled.div`
  width: 100%;
  height: 120px;
  overflow: hidden;
  background: #f8f9fa;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const NoImage = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 12px;
  background: #f8f9fa;
`;

export const LectureCardContent = styled.div`
  padding: 12px;
`;

export const LectureTitle = styled.h4`
  font-size: 14px;
  font-weight: 600;
  color: #171719;
  margin: 0 0 4px 0;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const LecturerName = styled.p`
  font-size: 12px;
  color: rgba(112, 115, 124, 0.8);
  margin: 0;
`;

export const RemoveLectureButton = styled.button`
  position: absolute;
  top: 8px;
  right: 8px;
  width: 24px;
  height: 24px;
  border: none;
  border-radius: 50%;
  background: rgba(229, 34, 34, 0.9);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.2s ease;
`;

export const AddLectureCard = styled.div<{ $disabled?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  border: 2px dashed rgba(112, 115, 124, 0.3);
  border-radius: 8px;
  background: #f8f9fa;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #666;
  font-size: 14px;
  gap: 8px;

  &:hover {
    border-color: #448181;
    background: rgba(68, 129, 129, 0.05);
    color: #448181;
  }

  ${({ $disabled }) =>
    $disabled &&
    css`
      opacity: 0.5;
      cursor: not-allowed;
    `}
`;

/* Lecture selection modal */
export const LectureModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(23, 23, 25, 0.52);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const ModalContent = styled.div`
  position: relative;
  background: white;
  border-radius: 12px;
  width: 90%;
  max-width: 800px;
  max-height: 80vh;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  z-index: 2001;
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  border-bottom: 1px solid rgba(112, 115, 124, 0.16);

  h3 {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: #171719;
  }

  button {
    width: 32px;
    height: 32px;
    border: none;
    border-radius: 50%;
    background: #f8f9fa;
    color: #666;
    font-size: 18px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      background: #e9ecef;
    }
  }
`;

export const ModalBody = styled.div`
  padding: 20px;
  max-height: 80vh;
  overflow-y: auto;
`;

/* Category modal */
export const CategoryModal = styled.div`
  width: 480px;
  height: 100vh;
  background: white;
  display: flex;
  flex-direction: column;
  padding: 24px;
  gap: 24px;
  overflow: hidden;

  @media (max-width: 768px) {
    width: 100vw;
    height: 100vh;
    padding: 16px;
  }
`;

export const ModalTitle = styled.h2`
  color: black;
  font-size: 24px;
  font-family: 'Pretendard Variable', sans-serif;
  font-weight: 700;
  line-height: 32.02px;
  margin: 0;
`;

export const CloseButton = styled.button`
  width: 28px;
  height: 28px;
  border: none;
  background: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
`;

export const CategoryModalBody = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 24px;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 4px;
  margin-right: -4px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(112, 115, 124, 0.3);
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: rgba(112, 115, 124, 0.5);
  }
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const FormLabel = styled.label`
  color: rgba(55, 56, 60, 0.61);
  font-size: 15px;
  font-family: 'Pretendard Variable', sans-serif;
  font-weight: 600;
  line-height: 22.01px;
  letter-spacing: 0.14px;
  margin: 0;
`;

export const FormInput = styled.input<{ $disabled?: boolean }>`
  width: 100%;
  height: 50px;
  padding: 12px;
  border: 1px solid rgba(112, 115, 124, 0.16);
  border-radius: 12px;
  background: white;
  font-size: 16px;
  font-family: 'Pretendard Variable', sans-serif;
  font-weight: 400;
  line-height: 26px;
  letter-spacing: 0.09px;
  color: rgba(55, 56, 60, 0.88);
  box-sizing: border-box;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &:focus {
    outline: none;
    border-color: #448181;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.03), 0 0 0 3px rgba(68, 129, 129, 0.1);
  }

  &::placeholder {
    color: rgba(55, 56, 60, 0.28);
  }

  ${({ $disabled }) =>
    $disabled &&
    css`
      background: #f4f4f5;
      color: rgba(55, 56, 60, 0.16);
      cursor: not-allowed;

      &::placeholder {
        color: rgba(55, 56, 60, 0.16);
      }
    `}
`;

export const SelectWrapper = styled.div`
  position: relative;
`;

export const FormSelect = styled.select`
  width: 100%;
  height: 48px;
  padding: 12px;
  border: 1px solid rgba(112, 115, 124, 0.16);
  border-radius: 12px;
  background: white;
  font-size: 16px;
  font-family: 'Pretendard Variable', sans-serif;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.09px;
  color: rgba(55, 56, 60, 0.88);
  cursor: pointer;
  appearance: none;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='rgba(55, 56, 60, 0.61)' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6,9 12,15 18,9'%3e%3c/polyline%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 16px;
  padding-right: 40px;

  &:focus {
    outline: none;
    border-color: #448181;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.03), 0 0 0 3px rgba(68, 129, 129, 0.1);
  }
`;

export const ImageUploadSection = styled.div`
  display: flex;
  gap: 24px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 16px;
  }
`;

export const ImageUploadGroup = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const ImageUploadBox = styled.div`
  height: 112px;
  display: flex;
  align-items: flex-start;
  gap: 24px;

  @media (max-width: 768px) {
    justify-content: center;
  }
`;

export const CategoryImageUpload = styled.div`
  width: 112px;
  height: 112px;
  border-radius: 12px;
  border: 1px solid rgba(112, 115, 124, 0.16);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: border-color 0.2s ease;

  &:hover {
    border-color: #448181;
  }

  @media (max-width: 768px) {
    width: 100px;
    height: 100px;
  }
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 24px;
  margin-top: auto;
`;

export const DeleteButton = styled.button`
  width: 160px;
  height: 48px;
  padding: 4px 16px;
  background: none;
  border: none;
  color: rgba(55, 56, 60, 0.61);
  font-size: 16px;
  font-family: 'Pretendard Variable', sans-serif;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0.09px;
  cursor: pointer;
  border-radius: 6px;
  transition: background-color 0.2s ease;

  &:hover {
    background: rgba(23, 23, 25, 0.1);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &:disabled:hover {
    background: none;
  }
`;

export const SaveButton = styled.button`
  width: 160px;
  height: 48px;
  background: #448181;
  border: none;
  border-radius: 12px;
  color: white;
  font-size: 16px;
  font-family: 'Pretendard Variable', sans-serif;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0.09px;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background: #3a6f6f;
  }

  &:disabled {
    background: rgba(68, 129, 129, 0.5);
    cursor: not-allowed;
  }

  &:disabled:hover {
    background: rgba(68, 129, 129, 0.5);
  }

  @media (max-width: 768px) {
    width: 100%;
  }

  @media (max-width: 480px) {
    width: 100%;
  }
`;

export const LectureList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const LectureListItem = styled.div<{ $alreadyAdded?: boolean }>`
  display: flex;
  align-items: center;
  padding: 12px;
  border: 1px solid rgba(112, 115, 124, 0.16);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  background: #fff;

  &:hover {
    border-color: #448181;
    background: rgba(68, 129, 129, 0.05);
  }

  ${({ $alreadyAdded }) =>
    $alreadyAdded &&
    css`
      opacity: 0.6;
      cursor: not-allowed;
      background: #f8f9fa;
    `}
`;

export const LectureListImage = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 8px;
  overflow: hidden;
  margin-right: 12px;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const LectureListContent = styled.div`
  flex: 1;

  h4 {
    margin: 0 0 4px 0;
    font-size: 14px;
    font-weight: 600;
    color: #171719;
  }

  p {
    margin: 0 0 8px 0;
    font-size: 12px;
    color: rgba(112, 115, 124, 0.8);
  }
`;

export const LectureTags = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
`;

export const Tag = styled.span`
  padding: 2px 6px;
  background: rgba(68, 129, 129, 0.1);
  color: #448181;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 500;
`;

export const AddedIndicator = styled.div`
  color: #28a745;
  font-size: 12px;
  font-weight: 600;
  margin-left: 12px;
`;

/* Image upload component */
export const ImageUpload = styled.div`
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  position: relative;
  border: 1px solid rgba(112, 115, 124, 0.16);
  cursor: pointer;
  transition: border-color 0.2s ease;
  z-index: 10;

  &:hover {
    border-color: #448181;
  }

  &.bannerImage {
    width: 336px;
    height: 116px;
    flex-shrink: 0;
  }

  &.categoryImageUpload {
    width: 112px;
    height: 112px;
    flex-shrink: 0;
  }

  @media (max-width: 768px) {
    &.bannerImage {
      width: 100%;
      height: 180px;
    }

    &.categoryImageUpload {
      width: 100px;
      height: 100px;
    }
  }
`;

export const ImagePlaceholder = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  position: relative;
  overflow: hidden;
  z-index: 11;
  pointer-events: auto;
`;

export const UploadIcon = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 1;
  z-index: 12;
  pointer-events: none;
`;

export const UploadedImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  display: block;
  pointer-events: none;
`;

/* Input field component */
export const InputField = styled.div`
  flex: 1;
  width: 100%;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`;

export const Input = styled.input`
  width: 100%;
  border-radius: 12px;
  border: 1px solid rgba(112, 115, 124, 0.16);
  background-color: white;
  padding: 12px;
  box-sizing: border-box;
  font-size: 16px;
  font-family: 'Pretendard JP', sans-serif;
  letter-spacing: 0.01em;
  line-height: 150%;
  color: rgba(55, 56, 60, 0.88);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &:focus {
    outline: none;
    border-color: #448181;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.03), 0 0 0 3px rgba(68, 129, 129, 0.1);
  }

  &::placeholder {
    color: rgba(55, 56, 60, 0.28);
  }
`;

/* Button component */
export const ButtonBase = styled.button<{
  $variant?: 'outlined' | 'primary' | 'text';
  $disabled?: boolean;
}>`
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 12px;
  cursor: pointer;
  font-family: 'Pretendard JP', sans-serif;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.01em;
  line-height: 150%;
  transition: all 0.2s ease;
  border: none;
  background: none;
  position: relative;
  overflow: hidden;

  ${({ $variant }) =>
    $variant === 'outlined' &&
    css`
      border: 1px solid rgba(112, 115, 124, 0.16);
      color: rgba(46, 47, 51, 0.88);
      background-color: white;

      &:hover {
        border-color: #448181;
        color: #448181;
      }
    `}

  ${({ $variant }) =>
    $variant === 'primary' &&
    css`
      background-color: #448181;
      color: white;
      padding: 12px 28px;

      &:hover {
        background-color: #3a6f6f;
      }
    `}

  ${({ $variant }) =>
    $variant === 'text' &&
    css`
      color: rgba(55, 56, 60, 0.61);
      padding: 4px 16px;

      &:hover {
        background-color: rgba(112, 115, 124, 0.05);
      }
    `}

  ${({ $disabled }) =>
    $disabled &&
    css`
      opacity: 0.4;
      cursor: not-allowed;
      pointer-events: none;

      &:hover {
        border-color: rgba(112, 115, 124, 0.16);
        color: rgba(46, 47, 51, 0.88);
      }
    `}
`;

/* Save section */
export const SaveSection = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: 24px;
  text-align: center;
  font-size: 16px;
  color: rgba(55, 56, 60, 0.61);
`;

export const SaveActions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 24px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 16px;
    width: 100%;
  }

  @media (max-width: 480px) {
    flex-direction: column;
    gap: 16px;
    width: 100%;
  }
`;

/* Category section */
export const CategorySection = styled.section`
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 8px;
`;

export const AddCategoryButton = styled.div`
  align-self: stretch;
  padding: 16px 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: background-color 0.2s ease;
  border-top: 1px solid rgba(112, 115, 124, 0.16);

  &:hover {
    background-color: rgba(68, 129, 129, 0.05);
  }
`;

export const TableContainer = styled.div`
  align-self: stretch;
  border-radius: 12px;
  border: 1px solid #e1e2e4;
  overflow: hidden;
  background-color: white;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  font-size: 13px;
`;

export const TableInner = styled.div`
  width: 100%;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
`;

export const TableHead = styled.div`
  width: fit-content;
  min-width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  position: relative;
  z-index: 2;
`;

export const TableHeadRow = styled.div`
  align-self: stretch;
  border-bottom: 1px solid rgba(112, 115, 124, 0.16);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 16px 20px;
  z-index: 1;
  background-color: rgba(112, 115, 124, 0.05);
`;

export const TableBody = styled.div`
  width: fit-content;
  min-width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  z-index: 1;
  font-size: 16px;
  color: #171719;
`;

export const TableBodyRow = styled.div<{ $selected?: boolean }>`
  align-self: stretch;
  border-bottom: 1px solid rgba(112, 115, 124, 0.16);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 16px 20px;
  transition: background-color 0.2s ease;
  cursor: pointer;

  &:hover {
    background-color: rgba(112, 115, 124, 0.05);
  }

  &:last-child {
    border-bottom: none;
  }

  ${({ $selected }) =>
    $selected &&
    css`
      background-color: rgba(0, 123, 255, 0.1);
      border-left: 3px solid #007bff;
    `}
`;

export const CellContainer = styled.div`
  align-self: stretch;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`;

export const CellText = styled.div`
  align-self: stretch;
  position: relative;
  letter-spacing: 0.01em;
  line-height: 150%;
  white-space: nowrap;
`;

export const HeaderCellText = styled(CellText)`
  letter-spacing: 0.02em;
  line-height: 138.5%;
  font-weight: 600;
  font-size: 13px;
  color: rgba(46, 47, 51, 0.88);
`;

export const CellOrder = styled.div<{ $isHeader?: boolean }>`
  width: 100px;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  padding: ${({ $isHeader }) => ($isHeader ? '0' : '0')};
  box-sizing: border-box;
`;

export const CellName = styled.div<{ $isHeader?: boolean }>`
  flex: 1;
  overflow: hidden;
  min-width: 120px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  padding: ${({ $isHeader }) => ($isHeader ? '0' : '0')};
`;

export const CellParent = styled.div<{ $isHeader?: boolean }>`
  width: 200px;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  padding: ${({ $isHeader }) => ($isHeader ? '0' : '0')};
  box-sizing: border-box;
`;

export const CellCount = styled.div<{ $isHeader?: boolean }>`
  width: 200px;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  padding: ${({ $isHeader }) => ($isHeader ? '0' : '0')};
  box-sizing: border-box;
`;

export const CellAction = styled.div<{ $isHeader?: boolean }>`
  width: 150px;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: ${({ $isHeader }) => ($isHeader ? 'flex-start' : 'center')};
  justify-content: flex-start;
  padding: ${({ $isHeader }) => ($isHeader ? '6px 0px 6px 20px' : '0px 20px')};
  box-sizing: border-box;
  gap: 8px;
  font-size: 12px;

  ${({ $isHeader }) =>
    $isHeader &&
    css`
      ${CellContainer} {
        min-height: 32px;
        align-items: center;
      }
    `}
`;

export const TableButton = styled.button`
  border-radius: 8px;
  border: 1px solid rgba(112, 115, 124, 0.16);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 7px 8px;
  position: relative;
  font-size: 12px;
  letter-spacing: 0.03em;
  line-height: 133.4%;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  background: white;
  color: rgba(46, 47, 51, 0.88);
  white-space: nowrap;

  &:hover {
    border-color: #448181;
    color: #448181;
  }
`;

export const TableButtonDelete = styled(TableButton)`
  color: #e52222;
  border-color: rgba(229, 34, 34, 0.3);

  &:hover {
    border-color: #e52222;
    color: #e52222;
  }
`;

/* Curation content */
export const CurationContent = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-end;
  gap: 16px;
`;

export const DescriptionInput = styled.div`
  flex: 1;
  font-size: 16px;
`;

export const CardGrid = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 16px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-wrap: wrap;
  }
`;

export const Card = styled.div`
  width: calc(25% - 12px);
  height: 175px;
  flex-shrink: 0;

  ${ImageUpload} {
    width: 100%;
    height: 100%;
  }

  @media (max-width: 768px) {
    width: calc(50% - 8px);
  }

  @media (max-width: 480px) {
    width: 100%;
  }
`;

/* File section */
export const FileSection = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 8px;
`;

export const FileList = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const FileItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border: 1px solid rgba(112, 115, 124, 0.16);
  border-radius: 8px;
  background: #fff;
`;

export const FileInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
`;

export const FileName = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #171719;
`;

export const FileSize = styled.div`
  font-size: 12px;
  color: rgba(112, 115, 124, 0.8);
`;

export const FileType = styled.div`
  font-size: 12px;
  color: rgba(112, 115, 124, 0.6);
`;

export const FileActions = styled.div`
  display: flex;
  gap: 8px;
`;

export const Loading = styled.div`
  text-align: center;
  padding: 20px;
  color: rgba(112, 115, 124, 0.8);
  font-size: 14px;
`;

export const EmptyMessage = styled.div`
  text-align: center;
  padding: 20px;
  color: rgba(112, 115, 124, 0.6);
  font-size: 14px;
`;
